import React, { useState } from 'react';
import { NewShowError, NewShowSuccess } from '../projectData';
import { NewUserVirification } from '../new-otp-verification';
import { submitConsentData } from '../api';
import { useNavigate } from 'react-router-dom';


const OtpTermsCondition = ({
    setShowTerms,
    reSendOtp,
    userToken,
    userData,
    setPrivacyStatus
}) => {
    const navigate = useNavigate()
    const [redemError, setRedemError] = useState('');
    const [success, setSuccess] = useState(null);
    const [showOtp, setShowOtp] = useState(true);

    const handleClose = () => {
        setShowTerms(true);
        setShowOtp(false);
        setRedemError('');
        setSuccess(null);
    };

    const reloadPage = () => {
        window.location.reload();
    };

    const handleTermsConditionSubmit = async () => {
        setRedemError('');

        submitConsentData({ privacy_policy_status: "yes", iirpl_sap_code: userData?.user?.iirpl_sap_code }).then((d) => {
            setShowOtp(false)
            if (Number(d.code) === 1) {
                setPrivacyStatus("yes")
            } else {
                setRedemError(d.message);

            }
        })
    };

    return (
        <div className="container vh-100 d-flex justify-content-center  mt-15">
            <div className="row w-100 justify-content-center">
                {redemError && (
                    <NewShowError error={redemError} closePopup={reloadPage} />
                )}

                {success && (
                    <NewShowSuccess
                        title="Terms And Conditions Updated Successfully"
                        success={success.message}
                        closePopup={() => navigate('/customer/dashboard')}
                    />
                )}

                {!redemError && !success && showOtp && (
                    <div className="col-sm-12 col-md-8 col-lg-6">
                        <NewUserVirification
                            title="Accept Terms And Conditions"
                            returnFunction={handleTermsConditionSubmit}
                            mobile={userData?.user?.phone}
                            closePOup={handleClose}
                            reSendOtp={reSendOtp}
                            description={`To proceed, please enter the OTP sent to your registered mobile number (${userData?.user?.phone.replace(/.(?=.{4})/g, '*')}) to confirm your acceptance of the Terms & Conditions and Privacy Policy shown on the previous screens.`}
                        />
                    </div>
                )}
            </div>
        </div>

    );
};

export default OtpTermsCondition;
